module.exports = __webpack_public_path__ + "img/theS.b7545c0b.png";